export default __webpack_public_path__ + "static/media/sub-image.a45f1266.png";